export const handleChangeDataPageFlashSale = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_FLASH_SALE', name, value
});